const monthMap = new Map([
  [1, { monthName: 'Janeiro', monthAcronym: 'Jan' }],
  [2, { monthName: 'Fevereiro', monthAcronym: 'Fev' }],
  [3, { monthName: 'Março', monthAcronym: 'Mar' }],
  [4, { monthName: 'Abril', monthAcronym: 'Abr' }],
  [5, { monthName: 'Maio', monthAcronym: 'Mai' }],
  [6, { monthName: 'Junho', monthAcronym: 'Jun' }],
  [7, { monthName: 'Julho', monthAcronym: 'Jul' }],
  [8, { monthName: 'Agosto', monthAcronym: 'Ago' }],
  [9, { monthName: 'Setembro', monthAcronym: 'Set' }],
  [10, { monthName: 'Outubro', monthAcronym: 'Out' }],
  [11, { monthName: 'Novembro', monthAcronym: 'Nov' }],
  [12, { monthName: 'Dezembro', monthAcronym: 'Dez' }],
]);

export const getMonthInfo = (monthNumber: number) => {
  return (
    monthMap.get(monthNumber) ?? { monthName: `${monthNumber}`, monthAcronym: `${monthNumber}` }
  );
};
